import SKY_EXT_1 from "./SKY_EXT_1";
export default {
  SKY_EXT_1,
};
